type SectionProps = {
  eyebrow?: string;
  title: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

export function Section({ eyebrow, title, children, className = "", style }: SectionProps) {
  return (
    <section className={`section ${className}`.trim()} style={style}>
      <div className="container">
        <div className="section-heading">
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          <h2>{title}</h2>
        </div>
        {children}
      </div>
    </section>
  );
}
